import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_skill_input = _resolveComponent("app-skill-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_education_input = _resolveComponent("app-education-input")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Create-Business-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "500px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      "close-on-press-escape": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Co-founder Profile",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "before-close": _ctx.closeModal,
      "close-delay": 200
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.saveData,
            size: "large",
            type: "primary",
            disabled: _ctx.disableSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Save ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          always: true,
          "max-height": "70vh"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "names",
                    label: "Full Names"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "Names",
                        modelValue: _ctx.form.names,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.names) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_divider),
                    _cache[3] || (_cache[3] = _createElementVNode("h4", {
                      "txt-center": "",
                      "mt-2": ""
                    }, "Skills", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.skills, (skill, index) => {
                      return (_openBlock(), _createBlock(_component_el_row, {
                        gutter: 16,
                        align: "middle",
                        justify: "center",
                        key: `skill-input-${index}${skill.name}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: index == 0 ? 18 : 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_app_skill_input, {
                                "w-100": "",
                                modelValue: _ctx.form.skills[index].name,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.skills[index].name) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["span"]),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tooltip, { content: "Years of experience" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "experience",
                                    label: "Years"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input_number, {
                                        "w-100": "",
                                        min: 0,
                                        max: 100,
                                        controls: false,
                                        placeholder: "EX: 5",
                                        modelValue: _ctx.form.skills[index].years,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.skills[index].years) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (index !== 0)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                "txt-right": "",
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  (index > 0)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        style: {"margin-bottom":"18px"},
                                        onClick: ($event: any) => (_ctx.removeSkill(index)),
                                        icon: "el-icon-delete",
                                        circle: "",
                                        size: "mini"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_el_button, {
                        class: "button-new-tag",
                        size: "small",
                        onClick: _ctx.addSkill,
                        round: "",
                        icon: "el-icon-plus"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" Add Skill ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createVNode(_component_el_divider),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("h4", {
                        "txt-center": "",
                        "mt-2": ""
                      }, "Education History", -1)),
                      _createVNode(_component_el_space, {
                        fill: "",
                        direction: "vertical"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.education, (edu, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `edu-input-${index}`
                            }, [
                              _createVNode(_component_app_education_input, {
                                index: index,
                                modelValue: _ctx.form.education[index],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.education[index]) = $event),
                                onRemove: ($event: any) => (_ctx.removeEducation(index))
                              }, null, 8, ["index", "modelValue", "onUpdate:modelValue", "onRemove"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_button, {
                          class: "button-new-tag",
                          size: "small",
                          onClick: _ctx.addEducation,
                          round: "",
                          icon: "el-icon-plus"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode(" Add Education ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "close-on-press-escape", "onOpen", "before-close"])
  ]))
}